import React, { ReactNode } from 'react'

import { MiniStat, StatArtwork } from '../styles'

interface SummaryStatProps {
  value: ReactNode
  label: string
  image: string
}

const SummaryStat = ({ image, label, value }: SummaryStatProps) => (
  <MiniStat>
    <StatArtwork aria-hidden="true">
      <img src={image} alt="" />
    </StatArtwork>
    <div className="stat-copy">
      <strong>{value}</strong>
      <small>{label}</small>
    </div>
  </MiniStat>
)

export default SummaryStat
